module.exports = __webpack_public_path__ + "static/media/background.fe885c63.jpg";